import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { format } from "timeago.js"
import { userRequest } from "../../requestMethods"
// Styles
import {
   Amount,
   Date,
   Container,
   Image,
   Table,
   TableHeader,
   TableRow,
   Title,
   User,
   UserName,
   Status,
   StyledButton,
} from "./WidgetLarges.styles"

const WidgetLarge = () => {
   const [users, setUsers] = useState([])
   const [orders, setOrders] = useState([])

   useEffect(() => {
      const getUsers = async () => {
         try {
            const res = await userRequest.get("users/?new=true")
            setUsers(res.data)
         } catch (err) {
            setUsers(["No users to fetch", err])
         }
      }
      const getOrders = async () => {
         try {
            const res = await userRequest.get("orders/?new=true")
            setOrders(res.data)
         } catch (err) {
            setOrders(["No Orders to fetch", err])
         }
      }
      getUsers()
      getOrders()
   }, [])

   const Button = ({ type }) => (
      <StyledButton
         buttonColor={
            type === "sent" ? "green" : type === "pending" ? "red" : "blue"
         }
      >
         {type}
      </StyledButton>
   )
   Button.propTypes = {
      type: PropTypes.string,
   }

   return (
      <Container>
         <Title>Latest transactions</Title>
         <Table>
            <TableRow>
               <TableHeader>Customer</TableHeader>
               <TableHeader>Date</TableHeader>
               <TableHeader>Amount</TableHeader>
               <TableHeader>Status</TableHeader>
            </TableRow>
            {orders?.map((order) => (
               <TableRow key={order._id}>
                  <User>
                     <Image
                        src={
                           users.find((item) => item._id === order.userId)
                              ?.img ||
                           "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/no_avatar.jpg?alt=media&token=c560d993-a555-4bf0-bb53-0f91f4d06e2f"
                        }
                     />
                     <UserName>
                        {
                           users.find((item) => item._id === order.userId)
                              ?.username
                        }
                     </UserName>
                  </User>
                  <Date>{format(order.createdAt)}</Date>
                  <Amount>{order.amount}€</Amount>
                  <Status>
                     <Button type={order.status} />
                  </Status>
               </TableRow>
            ))}
         </Table>
      </Container>
   )
}

export default WidgetLarge
